import React from 'react';
import { RequestProvider } from '../hooks/useRequest';
import { RequestCalculationProvider } from '../hooks/useRequestCalculation';
import { useRequestContext } from '../hooks/useRequest';
import { RequestCalculationTemplate } from './templates/RequestCalculationTemplate';

export function RequestCalculationPage() {
  return (
    <RequestProvider>
      <RequestCalculationProvider useRequestContext={useRequestContext}>
        <RequestCalculationTemplate />
      </RequestCalculationProvider>
    </RequestProvider>
  );
}
